import React from 'react';
import { useScreen } from '../lib/useScreen';
import { useTracker } from '../lib/useTracker';

const C = { turquesa:'#5dc1b9', mango:'#FDBE02', coral:'#eb636b', morado:'#534AB7', verde:'#1D9E75', dark:'#0a0a0a' };
const font = "'DM Sans', sans-serif";
const serif = "'DM Serif Display', serif";
const glass = { background:'rgba(255,255,255,0.05)', backdropFilter:'blur(30px)', WebkitBackdropFilter:'blur(30px)', border:'1px solid rgba(255,255,255,0.1)', borderRadius:20 };

const WA_NUMBER = '527122713864';
const WA_COTIZAR = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent('Hola, quiero cotizar Onsite Growth para mi negocio. Me gustaría saber más sobre sus servicios.')}`;
const WA_PREGUNTAS = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent('Hola, tengo algunas preguntas sobre Onsite Growth México. ¿Me pueden ayudar?')}`;

const SERVICIOS = [
  { emoji:'🎬', name:'Videos profesionales', desc:'Contenido de video que cuenta la historia real de tu negocio.' },
  { emoji:'📸', name:'Fotografía de producto', desc:'Fotos que hacen justicia a lo que vendes.' },
  { emoji:'🚁', name:'Tomas con drone', desc:'Perspectivas aéreas de tu negocio y su entorno.' },
  { emoji:'📖', name:'Storytelling', desc:'Tu historia contada de forma que conecte con clientes.' },
  { emoji:'🌐', name:'Sitio web', desc:'Presencia digital profesional para tu negocio.' },
  { emoji:'📋', name:'Estrategia de contenido', desc:'Plan de qué publicar, cuándo y dónde.' },
  { emoji:'📱', name:'Redes sociales', desc:'Configuración y optimización de tus perfiles.' },
  { emoji:'🎨', name:'Branding', desc:'Identidad visual coherente para tu marca.' },
  { emoji:'✏️', name:'Diseño de logo', desc:'Logo profesional que represente tu esencia.' },
  { emoji:'📣', name:'Campañas de ads', desc:'Publicidad digital para atraer clientes reales.' },
];

const PASOS = [
  { num:'01', emoji:'🚗', title:'Visitamos tu negocio', desc:'Vamos directamente a donde estés. No importa si estás en una ciudad grande o en un pueblo. Llegamos, conocemos tu espacio, tu gente, tu producto.' },
  { num:'02', emoji:'📸', title:'Levantamos contenido real', desc:'En sitio producimos videos, fotos, tomas de drone y entrevistas. Contenido auténtico, no stock ni IA. Tu negocio real, tus clientes reales.' },
  { num:'03', emoji:'🚀', title:'Construimos tu presencia digital', desc:'Con el material levantado, creamos tu sitio web, tus redes, tu estrategia de contenido y tus primeras campañas. Todo listo para vender.' },
];

const CLIENTES = [
  { name:'Talabartería GA', location:'Jocotitlán, Estado de México', desc:'Marca de cuero artesanal con tradición familiar.', color:C.coral, emoji:'🐎' },
  { name:'Rústico El Once', location:'Amealco de Bonfil, Querétaro', desc:'Restaurante con animales y experiencia rural.', color:C.turquesa, emoji:'🌿' },
  { name:'PlayWithUs', location:'Ciudad de México', desc:'Centro de entretenimiento y eventos.', color:C.mango, emoji:'🎮' },
];

export default function OnsiteGrowthLanding() {
  const { isMobile } = useScreen();
  useTracker('onsite-growth', null);

  return (
    <div style={{ fontFamily:font, color:'#fff', background:C.dark, minHeight:'100vh' }}>

      {/* NAV */}
      <nav style={{ maxWidth:900, margin:'0 auto', padding:isMobile?'1rem':'1.2rem 1.5rem', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
        <div style={{ display:'flex', alignItems:'center', gap:10 }}>
          <div style={{ width:38, height:38, borderRadius:'50%', background:'linear-gradient(135deg, #534AB7, #1D9E75)', display:'flex', alignItems:'center', justifyContent:'center' }}>
            <span style={{ color:'#fff', fontSize:12, fontWeight:500 }}>T&D</span>
          </div>
          <span style={{ fontSize:16, fontWeight:500 }}>Onsite Growth MX</span>
        </div>
        <a href={WA_COTIZAR} target="_blank" rel="noopener noreferrer" style={{ padding:'10px 24px', background:C.verde, color:'#fff', border:'none', borderRadius:50, fontSize:13, fontWeight:500, textDecoration:'none', fontFamily:font }}>
          Cotizar →
        </a>
      </nav>

      {/* HERO */}
      <section style={{ maxWidth:800, margin:'0 auto', padding:isMobile?'3rem 1rem':'5rem 1.5rem', textAlign:'center' }}>
        <p style={{ fontSize:12, color:C.verde, fontWeight:500, letterSpacing:2, margin:'0 0 14px' }}>ONSITE GROWTH MÉXICO</p>
        <h1 style={{ fontFamily:serif, fontSize:isMobile?28:48, fontWeight:400, margin:'0 0 16px', lineHeight:1.15 }}>
          Marcas reales en <span style={{ color:C.verde }}>lugares reales</span>
        </h1>
        <p style={{ fontSize:isMobile?15:18, color:'rgba(255,255,255,0.6)', lineHeight:1.7, maxWidth:580, margin:'0 auto 32px' }}>
          Negocios fuera de focos urbanos también merecen presencia digital de calidad. Vamos a donde estés y construimos tu marca digital desde cero.
        </p>
        <div style={{ display:'flex', gap:12, justifyContent:'center', flexDirection:isMobile?'column':'row', alignItems:'center' }}>
          <a href={WA_COTIZAR} target="_blank" rel="noopener noreferrer" style={{ padding:isMobile?'16px 36px':'18px 44px', background:C.verde, color:'#fff', border:'none', borderRadius:50, fontSize:isMobile?15:17, fontWeight:500, textDecoration:'none', fontFamily:font, boxShadow:'0 0 30px rgba(29,158,117,0.3)', width:isMobile?'100%':'auto', textAlign:'center', display:'inline-block' }}>
            Quiero cotizar →
          </a>
          <a href={WA_PREGUNTAS} target="_blank" rel="noopener noreferrer" style={{ padding:isMobile?'16px 36px':'18px 44px', background:'transparent', color:'#fff', border:'1px solid rgba(255,255,255,0.2)', borderRadius:50, fontSize:isMobile?15:17, fontWeight:500, textDecoration:'none', fontFamily:font, width:isMobile?'100%':'auto', textAlign:'center', display:'inline-block' }}>
            Tengo preguntas
          </a>
        </div>
      </section>

      {/* 10 SERVICIOS */}
      <section style={{ maxWidth:900, margin:'0 auto', padding:isMobile?'2rem 1rem':'3rem 1.5rem' }}>
        <p style={{ fontSize:12, color:C.turquesa, fontWeight:500, letterSpacing:2, textAlign:'center', margin:'0 0 8px' }}>QUÉ HACEMOS</p>
        <p style={{ fontFamily:serif, fontSize:isMobile?22:30, textAlign:'center', margin:'0 0 32px' }}>10 servicios, 1 visita</p>
        <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr':'repeat(2, 1fr)', gap:12 }}>
          {SERVICIOS.map((s, i) => (
            <div key={i} style={{ ...glass, padding:'18px 20px', display:'flex', alignItems:'flex-start', gap:14 }}>
              <span style={{ fontSize:28, flexShrink:0, marginTop:2 }}>{s.emoji}</span>
              <div>
                <p style={{ fontSize:15, fontWeight:500, margin:'0 0 4px' }}>{s.name}</p>
                <p style={{ fontSize:13, color:'rgba(255,255,255,0.55)', lineHeight:1.6, margin:0 }}>{s.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CÓMO FUNCIONA */}
      <section style={{ maxWidth:900, margin:'0 auto', padding:isMobile?'2rem 1rem':'3rem 1.5rem' }}>
        <p style={{ fontSize:12, color:C.mango, fontWeight:500, letterSpacing:2, textAlign:'center', margin:'0 0 8px' }}>CÓMO FUNCIONA</p>
        <p style={{ fontFamily:serif, fontSize:isMobile?22:30, textAlign:'center', margin:'0 0 32px' }}>3 pasos, sin complicaciones</p>
        <div style={{ display:'flex', flexDirection:isMobile?'column':'row', gap:16 }}>
          {PASOS.map((p, i) => (
            <div key={i} style={{ ...glass, flex:1, padding:'24px 20px', position:'relative' }}>
              <span style={{ position:'absolute', top:14, right:16, fontSize:11, fontWeight:700, color:C.mango, background:'rgba(253,190,2,0.1)', padding:'3px 10px', borderRadius:50 }}>{p.num}</span>
              <p style={{ fontSize:32, margin:'0 0 12px' }}>{p.emoji}</p>
              <p style={{ fontSize:17, fontWeight:500, margin:'0 0 8px' }}>{p.title}</p>
              <p style={{ fontSize:13, color:'rgba(255,255,255,0.6)', lineHeight:1.7, margin:0 }}>{p.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CLIENTES */}
      <section style={{ maxWidth:900, margin:'0 auto', padding:isMobile?'2rem 1rem':'3rem 1.5rem' }}>
        <p style={{ fontSize:12, color:C.coral, fontWeight:500, letterSpacing:2, textAlign:'center', margin:'0 0 8px' }}>CLIENTES REALES</p>
        <p style={{ fontFamily:serif, fontSize:isMobile?22:30, textAlign:'center', margin:'0 0 8px' }}>Ya lo hicimos aquí</p>
        <p style={{ fontSize:14, color:'rgba(255,255,255,0.5)', textAlign:'center', margin:'0 0 32px' }}>Negocios reales en lugares reales de México</p>
        <div style={{ display:'flex', flexDirection:isMobile?'column':'row', gap:16 }}>
          {CLIENTES.map((c, i) => (
            <div key={i} style={{ ...glass, flex:1, padding:'24px 20px', borderTop:`3px solid ${c.color}` }}>
              <p style={{ fontSize:36, margin:'0 0 12px' }}>{c.emoji}</p>
              <p style={{ fontSize:18, fontWeight:500, margin:'0 0 4px' }}>{c.name}</p>
              <p style={{ fontSize:12, color:c.color, fontWeight:500, margin:'0 0 10px' }}>📍 {c.location}</p>
              <p style={{ fontSize:13, color:'rgba(255,255,255,0.6)', lineHeight:1.6, margin:0 }}>{c.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA FINAL */}
      <section style={{ maxWidth:600, margin:'0 auto', padding:isMobile?'2rem 1rem':'4rem 1.5rem', textAlign:'center' }}>
        <div style={{ ...glass, padding:isMobile?'2rem 1.5rem':'3rem', borderTop:`3px solid ${C.verde}` }}>
          <p style={{ fontFamily:serif, fontSize:isMobile?24:32, margin:'0 0 8px' }}>¿Tu negocio está listo?</p>
          <p style={{ fontSize:14, color:'rgba(255,255,255,0.5)', margin:'0 0 28px', lineHeight:1.6 }}>
            No importa dónde estés en México. Si tienes un negocio real, vamos a ti y lo transformamos en una marca digital.
          </p>
          <div style={{ display:'flex', flexDirection:'column', gap:12, alignItems:'center' }}>
            <a href={WA_COTIZAR} target="_blank" rel="noopener noreferrer" style={{ padding:'16px 44px', background:C.verde, color:'#fff', border:'none', borderRadius:50, fontSize:16, fontWeight:500, textDecoration:'none', fontFamily:font, boxShadow:'0 0 30px rgba(29,158,117,0.3)', width:isMobile?'100%':'auto', textAlign:'center', display:'inline-block' }}>
              Cotizar por WhatsApp →
            </a>
            <a href={WA_PREGUNTAS} target="_blank" rel="noopener noreferrer" style={{ fontSize:13, color:'rgba(255,255,255,0.5)', textDecoration:'none' }}>
              ¿Tienes preguntas? Escríbenos →
            </a>
          </div>
          <p style={{ fontSize:11, color:'rgba(255,255,255,0.3)', margin:'20px 0 0' }}>
            WhatsApp directo con Bruno · Respuesta en menos de 24 hrs
          </p>
        </div>
      </section>

      {/* FOOTER */}
      <footer style={{ maxWidth:900, margin:'0 auto', padding:'2rem 1.5rem', textAlign:'center', borderTop:'1px solid rgba(255,255,255,0.08)' }}>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:8, marginBottom:8 }}>
          <div style={{ width:26, height:26, borderRadius:'50%', background:'linear-gradient(135deg, #534AB7, #1D9E75)', display:'flex', alignItems:'center', justifyContent:'center' }}>
            <span style={{ color:'#fff', fontSize:9, fontWeight:500 }}>T&D</span>
          </div>
          <span style={{ fontSize:13, fontWeight:500, color:'rgba(255,255,255,0.6)' }}>Thinker & Doer · Onsite Growth MX</span>
        </div>
        <p style={{ fontSize:12, color:'rgba(255,255,255,0.3)', margin:'0 0 12px' }}>Servicio presencial en todo México</p>
        <div style={{ display:'flex', justifyContent:'center', gap:16 }}>
          <a href="/terminos" style={{ fontSize:11, color:'rgba(255,255,255,0.35)', textDecoration:'none' }}>Términos</a>
          <a href="/privacidad" style={{ fontSize:11, color:'rgba(255,255,255,0.35)', textDecoration:'none' }}>Privacidad</a>
        </div>
      </footer>
    </div>
  );
}
